'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const init_1 = require("./class/init");
const to_page_top_1 = require("./class/to-page-top");
const img_slider_1 = require("./class/img-slider");
$(() => {
    new init_1.default();
    new to_page_top_1.default();
    new img_slider_1.default();
});
